<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基础信息
          </div>
        </template>
        <div class="collapse-content">
          <formItem
            ref="baseInfoFormRef"
            :params="baseInfoData"
            :columns="getBaseColumns"
            :rules="baseRules"
            labelWidth="120px"
          >
          </formItem>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ pageType == '0' ? '审批信息' : '审核记录' }}
          </div>
        </template>
        <div class="collapse-content">
          <template v-if="pageType == '0'">
            <el-form :model="baseInfoData" :rules="baseRules">
              <el-form-item label="审批信息" prop="info" label-width="120px">
                <el-input
                  placeholder="请输入"
                  v-model="baseInfoData.info"
                  type="textarea"
                  :rows="3"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </template>
          <template v-else>
            <DepositAuditRecordTable :tableData="depositRecordData"></DepositAuditRecordTable>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="bottomButtons" v-if="pageType == '0'">
      <div style="padding: 20px; background: #fff">
        <el-button type="primary" @click="btnClick('accept')" class="fixed-bottom-btn"
          >通过
        </el-button>
        <el-button type="primary" @click="btnClick('reject')" class="fixed-bottom-btn"
          >驳回
        </el-button>
        <el-button type="primary" @click="btnClick('cancel')" class="fixed-bottom-btn"
          >取消
        </el-button>
      </div>
    </footer>
  </el-card>
</template>

<script>
  import formItem from '../../../../intermodality/common/components/form-item.vue';
  import DepositDetailMixin from '../../mixins/DepositDetailMixin';
  import DepositAuditRecordTable from '../../common/DepositAuditRecordTable.vue';
  import { depositApplyCells, depositDetailCells } from '../detail/columns/baseColumns';

  export default {
    name: 'DepositAuditDetail',
    mixins: [DepositDetailMixin],
    components: {
      formItem,
      DepositAuditRecordTable,
    },
    mounted() {
      this.pageType = this.$route.query.pageType;
      if (this.$route.query?.id) {
        this.baseInfoData.id = this.$route.query?.id;
      }

      this.initAuditDetail();
    },
    data() {
      return {
        loading: false,
        activeCollapses: ['1', '2'],
        //0审核操作1审核详情
        pageType: '0',
      };
    },
    computed: {
      getBaseColumns() {
        if (this.pageType == '0') {
          return depositApplyCells();
        } else if (this.pageType == '1') {
          return depositDetailCells();
        }
        return depositApplyCells();
      },
      baseRules() {
        return {
          info: [
            {
              required: true,
              message: '必填字段',
            },
          ],
        };
      },
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .bottomButtons {
    padding-top: 20px;
    text-align: left;
  }
</style>
